import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { onLoadFileInput } from 'shared/lib/load-file'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Button } from 'shared/ui/button'
import { ImageLazy } from 'shared/ui/image-lazy'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface Props {
  title?: string
  value?: File
  onError?: () => void
  onLoaded?: (file: File) => void
}

export const LoadFile = ({ title, value, onLoaded, onError }: Props) => {
  const { t } = useTranslation()

  const [file, setFile] = useState<File | undefined | string>(value)

  const onLoadFileHandler = () => {
    onLoadFileInput({
      accept: 'image/jpeg,image/png,image/webp',
      onLoadFile: (file) => {
        onLoaded?.(file)
        setFile(file)
      },
      onError,
    })
  }

  const imageLink =
    (typeof file !== 'string' && file && URL.createObjectURL(file)) || false
  return (
    <div className={s.container}>
      <Paper padding={[20]}>
        <div className={clsx(file && s.wrapperLoaded)}>
          <p className={clsx('semi-bold-17', s.title)}>{title}</p>

          {file && (
            <AppIcon
              className={s.icon}
              id={AllIcons.DONE_MY_ORDERS}
            />
          )}

          {imageLink && (
            <div className={s.loadedImage}>
              <div onClick={onLoadFileHandler}>
                <ImageLazy
                  src={imageLink}
                  className={s.image}
                />
              </div>
            </div>
          )}

          <Button
            variant="grey"
            onClick={onLoadFileHandler}
            className={clsx(Boolean(file) && s.loadedFile, s.button)}
          >
            <div className={clsx('semi-bold-17', s.buttonContent)}>
              {Boolean(file) ? (
                <>
                  <AppIcon
                    id={AllIcons.REFRESH}
                    width={24}
                    height={24}
                  />{' '}
                  {t('change')}
                </>
              ) : (
                <>
                  <AppIcon
                    id={AllIcons.PLUS}
                    width={24}
                    height={24}
                  />{' '}
                  {t('select_without_date')}
                </>
              )}
            </div>
          </Button>
        </div>
      </Paper>
    </div>
  )
}
